'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackPageView } from '@/lib/gtag';
import { trackMetaPageView } from '@/lib/meta-pixel';

export function GtagPageView() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;
    trackPageView(pathname);
    trackMetaPageView();
  }, [pathname]);

  return null;
}
